import * as Yup from 'yup'

export const setupValidationSchema = () => {
  return (
    Yup.object().shape({
      existing_cover: Yup.number('This should be a number')
        .typeError('This should be a number')
        .required('A value for existing cover is required')
        .min(0, `You can't have a negative existing cover value`),
      monthly_budget_expenses: Yup.number('This should be a number')
        .typeError('This should be a number')
        .required('A value for monthly budget is required')
        .min(0, `You can't have a negative monthly budget value`),
    })
  )
}
